var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg1",
    width: 599.32001,
    height: 295.89334,
    viewBox: "0 0 599.32001 295.89334",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "group-R5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2",
    d: "m 2117.46,1032.14 h 28.9 c 11.44,0 20.8,1.54 28.09,4.59 7.28,3.05 13,7.29 17.15,12.69 4.15,5.4 6.97,11.75 8.46,19.03 1.49,7.29 2.23,15.16 2.23,23.62 0,8.46 -0.74,16.33 -2.23,23.62 -1.49,7.28 -4.31,13.63 -8.46,19.03 -4.15,5.41 -9.87,9.63 -17.15,12.69 -7.29,3.06 -16.65,4.58 -28.09,4.58 h -28.9 z m -29.38,143.82 h 69.56 c 12.85,0 23.97,-2.19 33.37,-6.58 9.4,-4.39 17.08,-10.38 23.03,-17.97 5.95,-7.61 10.38,-16.49 13.28,-26.68 2.9,-10.19 4.35,-21.07 4.35,-32.66 0,-11.6 -1.45,-22.49 -4.35,-32.67 -2.9,-10.18 -7.33,-19.07 -13.28,-26.67 -5.95,-7.6 -13.63,-13.6 -23.03,-17.97 -9.4,-4.39 -20.52,-6.58 -33.37,-6.58 h -69.56 v 167.78",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,295.89333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3",
    d: "m 2250.46,1175.96 h 30.55 l 42.07,-132.77 h 0.47 l 43.01,132.77 h 29.84 l -57.34,-167.78 h -32.67 l -55.93,167.78",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,295.89333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4",
    d: "m 2575.55,1008.18 h -112.33 c 0.16,13.62 3.44,25.52 9.87,35.71 6.42,10.19 15.19,19.04 26.32,26.56 5.32,3.91 10.88,7.71 16.68,11.39 5.8,3.69 11.13,7.64 15.98,11.87 4.86,4.23 8.86,8.81 11.99,13.75 3.13,4.94 4.78,10.61 4.94,17.04 0,2.97 -0.36,6.14 -1.06,9.52 -0.7,3.36 -2.08,6.5 -4.11,9.4 -2.04,2.89 -4.86,5.32 -8.47,7.28 -3.6,1.96 -8.3,2.94 -14.09,2.94 -5.34,0 -9.76,-1.06 -13.29,-3.17 -3.52,-2.12 -6.34,-5.02 -8.45,-8.7 -2.12,-3.68 -3.68,-8.03 -4.7,-13.04 -1.03,-5.02 -1.61,-10.43 -1.77,-16.22 h -26.78 c 0,9.09 1.21,17.51 3.64,25.27 2.42,7.75 6.07,14.45 10.93,20.09 4.85,5.64 10.76,10.06 17.74,13.28 6.97,3.2 15.07,4.81 24.32,4.81 10.02,0 18.41,-1.64 25.15,-4.93 6.73,-3.29 12.18,-7.45 16.33,-12.46 4.15,-5.01 7.09,-10.46 8.81,-16.33 1.72,-5.87 2.58,-11.48 2.58,-16.8 0,-6.58 -1.01,-12.54 -3.04,-17.86 -2.05,-5.33 -4.79,-10.22 -8.24,-14.69 -3.44,-4.46 -7.36,-8.58 -11.74,-12.34 -4.39,-3.76 -8.93,-7.28 -13.64,-10.57 -4.69,-3.29 -9.4,-6.43 -14.09,-9.4 -4.71,-2.98 -9.05,-5.96 -13.05,-8.93 -4,-2.97 -7.48,-6.07 -10.46,-9.28 -2.97,-3.22 -5.01,-6.62 -6.1,-10.23 h 80.13 v -23.96",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,295.89333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5",
    d: "m 2661.8,1027.21 c 5.79,0 10.65,1.68 14.57,5.05 3.91,3.37 7.01,7.91 9.28,13.63 2.27,5.72 3.87,12.41 4.82,20.09 0.94,7.68 1.41,15.83 1.41,24.44 0,8.62 -0.47,16.72 -1.41,24.32 -0.95,7.6 -2.55,14.3 -4.82,20.1 -2.27,5.79 -5.37,10.37 -9.28,13.74 -3.92,3.37 -8.78,5.06 -14.57,5.06 -5.96,0 -10.85,-1.69 -14.69,-5.06 -3.85,-3.37 -6.89,-7.95 -9.17,-13.74 -2.26,-5.8 -3.88,-12.5 -4.81,-20.1 -0.94,-7.6 -1.41,-15.7 -1.41,-24.32 0,-8.61 0.47,-16.76 1.41,-24.44 0.93,-7.68 2.55,-14.37 4.81,-20.09 2.28,-5.72 5.32,-10.26 9.17,-13.63 3.84,-3.37 8.73,-5.05 14.69,-5.05 z m 0,148.75 c 11.75,0 21.34,-2.7 28.79,-8.1 7.43,-5.41 13.23,-12.3 17.38,-20.68 4.15,-8.39 6.97,-17.59 8.47,-27.62 1.48,-10.03 2.22,-19.74 2.22,-29.14 0,-9.4 -0.74,-19.11 -2.22,-29.14 -1.5,-10.03 -4.32,-19.23 -8.47,-27.6 -4.15,-8.39 -9.95,-15.28 -17.38,-20.69 -7.45,-5.4 -17.04,-8.1 -28.79,-8.1 -11.75,0 -21.35,2.7 -28.79,8.1 -7.44,5.41 -13.24,12.3 -17.39,20.69 -4.15,8.37 -6.98,17.57 -8.46,27.6 -1.49,10.03 -2.24,19.74 -2.24,29.14 0,9.4 0.75,19.11 2.24,29.14 1.48,10.03 4.31,19.23 8.46,27.62 4.15,8.38 9.95,15.27 17.39,20.68 7.44,5.4 17.04,8.1 28.79,8.1",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,295.89333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6",
    d: "m 2860.37,1008.18 h -112.33 c 0.15,13.62 3.45,25.52 9.87,35.71 6.43,10.19 15.2,19.04 26.32,26.56 5.33,3.91 10.89,7.71 16.69,11.39 5.79,3.69 11.12,7.64 15.98,11.87 4.85,4.23 8.84,8.81 11.99,13.75 3.12,4.94 4.77,10.61 4.93,17.04 0,2.97 -0.35,6.14 -1.06,9.52 -0.71,3.36 -2.08,6.5 -4.12,9.4 -2.03,2.89 -4.85,5.32 -8.45,7.28 -3.61,1.96 -8.3,2.94 -14.1,2.94 -5.33,0 -9.75,-1.06 -13.28,-3.17 -3.52,-2.12 -6.34,-5.02 -8.46,-8.7 -2.11,-3.68 -3.68,-8.03 -4.7,-13.04 -1.02,-5.02 -1.61,-10.43 -1.76,-16.22 h -26.8 c 0,9.09 1.22,17.51 3.65,25.27 2.43,7.75 6.07,14.45 10.93,20.09 4.85,5.64 10.77,10.06 17.74,13.28 6.97,3.2 15.08,4.81 24.33,4.81 10.02,0 18.4,-1.64 25.14,-4.93 6.73,-3.29 12.18,-7.45 16.33,-12.46 4.15,-5.01 7.09,-10.46 8.81,-16.33 1.73,-5.87 2.59,-11.48 2.59,-16.8 0,-6.58 -1.02,-12.54 -3.06,-17.86 -2.03,-5.33 -4.78,-10.22 -8.22,-14.69 -3.45,-4.46 -7.37,-8.58 -11.75,-12.34 -4.39,-3.76 -8.94,-7.28 -13.63,-10.57 -4.7,-3.29 -9.4,-6.43 -14.11,-9.4 -4.69,-2.98 -9.04,-5.96 -13.03,-8.93 -4,-2.97 -7.49,-6.07 -10.46,-9.28 -2.98,-3.22 -5.02,-6.62 -6.11,-10.23 h 80.13 v -23.96",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,295.89333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path7",
    d: "m 2889.51,1172.67 h 112.57 v -22.32 c -8.62,-9.72 -16.45,-19.78 -23.5,-30.2 -7.05,-10.42 -13.2,-21.46 -18.45,-33.13 -5.25,-11.68 -9.51,-24.01 -12.8,-37.02 -3.3,-13 -5.49,-26.94 -6.59,-41.82 h -29.37 c 0.94,13 3.17,25.85 6.7,38.53 3.52,12.69 8.06,24.99 13.63,36.9 5.56,11.9 12.02,23.34 19.39,34.31 7.36,10.96 15.27,21.22 23.73,30.78 h -85.31 v 23.97",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,295.89333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path8",
    d: "m 1439.57,824.102 c 0,-6.43 1.1,-11.911 3.29,-16.454 2.19,-4.546 5.25,-8.269 9.17,-11.16 3.91,-2.898 8.42,-5.019 13.51,-6.347 5.09,-1.34 10.61,-2 16.57,-2 6.42,0 11.9,0.738 16.45,2.23 4.54,1.488 8.22,3.41 11.04,5.77 2.82,2.339 4.86,5.05 6.11,8.097 1.25,3.063 1.88,6.141 1.88,9.282 0,6.429 -1.45,11.16 -4.35,14.218 -2.9,3.051 -6.07,5.203 -9.51,6.461 -5.96,2.192 -12.89,4.27 -20.8,6.231 -7.91,1.961 -17.67,4.511 -29.26,7.64 -7.2,1.879 -13.2,4.352 -17.98,7.399 -4.78,3.062 -8.57,6.472 -11.39,10.23 -2.82,3.762 -4.82,7.75 -5.99,11.981 -1.18,4.23 -1.77,8.531 -1.77,12.922 0,8.468 1.77,15.777 5.29,21.968 3.52,6.192 8.19,11.321 13.98,15.399 5.8,4.07 12.37,7.082 19.74,9.051 7.37,1.949 14.81,2.929 22.33,2.929 8.77,0 17.03,-1.14 24.79,-3.398 7.76,-2.281 14.57,-5.692 20.45,-10.231 5.87,-4.539 10.53,-10.14 13.98,-16.8 3.44,-6.661 5.17,-14.379 5.17,-23.149 h -29.38 c -0.78,10.809 -4.46,18.449 -11.04,22.91 -6.58,4.469 -14.96,6.699 -25.15,6.699 -3.45,0 -6.97,-0.351 -10.57,-1.05 -3.61,-0.711 -6.9,-1.891 -9.87,-3.532 -2.98,-1.636 -5.45,-3.878 -7.41,-6.699 -1.95,-2.82 -2.93,-6.347 -2.93,-10.578 0,-5.949 1.84,-10.609 5.52,-13.98 3.68,-3.371 8.5,-5.911 14.45,-7.641 0.62,-0.148 3.1,-0.82 7.41,-1.988 4.3,-1.172 9.12,-2.473 14.45,-3.883 5.32,-1.41 10.53,-2.777 15.63,-4.109 5.08,-1.329 8.73,-2.309 10.92,-2.942 5.49,-1.719 10.26,-4.066 14.34,-7.047 4.07,-2.98 7.48,-6.383 10.22,-10.222 2.74,-3.84 4.78,-7.95 6.11,-12.34 1.33,-4.379 2,-8.77 2,-13.16 0,-9.387 -1.92,-17.43 -5.76,-24.079 -3.84,-6.66 -8.89,-12.109 -15.16,-16.339 -6.26,-4.231 -13.39,-7.321 -21.38,-9.282 -7.99,-1.961 -16.14,-2.937 -24.44,-2.937 -9.56,0 -18.57,1.18 -27.03,3.527 -8.46,2.352 -15.82,5.949 -22.09,10.813 -6.27,4.847 -11.28,11.078 -15.04,18.679 -3.76,7.598 -5.72,16.559 -5.87,26.911 h 29.37",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,295.89333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path9",
    d: "m 1662.58,849.012 c -1.09,7.519 -4.11,13.187 -9.04,17.039 -4.94,3.84 -11.17,5.75 -18.69,5.75 -3.44,0 -7.12,-0.59 -11.04,-1.762 -3.92,-1.18 -7.52,-3.367 -10.81,-6.578 -3.29,-3.211 -6.03,-7.68 -8.22,-13.402 -2.2,-5.719 -3.29,-13.188 -3.29,-22.438 0,-5.012 0.58,-10.031 1.76,-15.043 1.18,-5.019 3.05,-9.476 5.64,-13.398 2.59,-3.91 5.91,-7.09 9.99,-9.508 4.07,-2.434 9,-3.641 14.8,-3.641 7.83,0 14.29,2.418 19.39,7.278 5.09,4.863 8.26,11.671 9.51,20.441 h 26.8 c -2.51,-15.82 -8.5,-27.922 -17.98,-36.301 -9.48,-8.379 -22.05,-12.57 -37.72,-12.57 -9.56,0 -17.98,1.609 -25.26,4.812 -7.29,3.207 -13.44,7.598 -18.45,13.168 -5.01,5.551 -8.81,12.172 -11.39,19.852 -2.59,7.668 -3.89,15.988 -3.89,24.91 0,9.078 1.26,17.629 3.77,25.617 2.5,7.981 6.26,14.922 11.28,20.801 5.01,5.871 11.24,10.492 18.68,13.859 7.44,3.364 16.17,5.051 26.2,5.051 7.05,0 13.75,-0.91 20.09,-2.699 6.35,-1.801 11.99,-4.5 16.92,-8.109 4.94,-3.602 8.97,-8.141 12.11,-13.629 3.13,-5.481 5.01,-11.981 5.64,-19.5 h -26.8",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,295.89333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path10",
    d: "m 1722.98,935.961 h 26.79 v -62.27 h 0.48 c 3.28,5.469 8.18,10.047 14.68,13.739 6.5,3.679 13.75,5.519 21.74,5.519 13.31,0 23.81,-3.437 31.49,-10.34 7.67,-6.89 11.51,-17.238 11.51,-31.007 v -83.43 h -26.79 v 76.367 c -0.31,9.563 -2.35,16.492 -6.11,20.801 -3.76,4.308 -9.63,6.461 -17.62,6.461 -4.55,0 -8.62,-0.821 -12.22,-2.461 -3.61,-1.649 -6.67,-3.93 -9.17,-6.82 -2.5,-2.899 -4.46,-6.309 -5.87,-10.219 -1.41,-3.922 -2.12,-8.082 -2.12,-12.449 v -71.68 h -26.79 v 167.789",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,295.89333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path11",
    d: "m 1944.59,829.039 c -4.08,-2.668 -9.1,-4.277 -15.05,-4.828 -5.95,-0.539 -11.9,-1.359 -17.85,-2.461 -2.83,-0.48 -5.57,-1.141 -8.23,-2 -2.67,-0.859 -5.02,-2.039 -7.05,-3.531 -2.04,-1.489 -3.65,-3.438 -4.82,-5.867 -1.17,-2.43 -1.76,-5.372 -1.76,-8.813 0,-2.98 0.86,-5.488 2.58,-7.519 1.73,-2.04 3.8,-3.649 6.23,-4.821 2.43,-1.179 5.09,-2 7.99,-2.469 2.9,-0.468 5.52,-0.699 7.87,-0.699 2.98,0 6.19,0.391 9.64,1.168 3.44,0.781 6.7,2.121 9.75,4 3.05,1.883 5.6,4.262 7.64,7.16 2.03,2.903 3.06,6.469 3.06,10.7 z m 26.78,-33.848 c 0,-3.293 0.43,-5.64 1.3,-7.05 0.86,-1.411 2.54,-2.11 5.05,-2.11 0.78,0 1.72,0 2.82,0 1.09,0 2.35,0.16 3.76,0.469 v -18.57 c -0.94,-0.309 -2.16,-0.66 -3.64,-1.051 -1.49,-0.391 -3.02,-0.738 -4.58,-1.07 -1.57,-0.309 -3.14,-0.539 -4.71,-0.7 -1.56,-0.16 -2.9,-0.23 -3.99,-0.23 -5.49,0 -10.03,1.101 -13.63,3.293 -3.61,2.187 -5.96,6.019 -7.05,11.508 -5.33,-5.16 -11.87,-8.918 -19.62,-11.282 -7.76,-2.347 -15.24,-3.519 -22.44,-3.519 -5.49,0 -10.74,0.742 -15.75,2.23 -5.02,1.493 -9.44,3.672 -13.28,6.59 -3.84,2.891 -6.89,6.571 -9.16,11.039 -2.28,4.461 -3.41,9.672 -3.41,15.621 0,7.52 1.37,13.629 4.11,18.34 2.74,4.692 6.35,8.371 10.81,11.039 4.47,2.66 9.48,4.582 15.04,5.75 5.56,1.184 11.16,2.082 16.81,2.711 4.85,0.93 9.47,1.602 13.86,2 4.38,0.383 8.26,1.051 11.63,1.992 3.37,0.938 6.03,2.387 7.99,4.348 1.96,1.961 2.94,4.902 2.94,8.82 0,3.43 -0.82,6.25 -2.47,8.45 -1.64,2.203 -3.68,3.882 -6.11,5.05 -2.43,1.18 -5.13,1.961 -8.11,2.352 -2.98,0.398 -5.79,0.59 -8.45,0.59 -7.52,0 -13.72,-1.563 -18.57,-4.699 -4.86,-3.133 -7.6,-7.993 -8.23,-14.571 h -26.78 c 0.46,7.828 2.34,14.34 5.64,19.5 3.28,5.18 7.47,9.328 12.56,12.469 5.1,3.121 10.85,5.32 17.28,6.57 6.42,1.258 13,1.879 19.74,1.879 5.95,0 11.83,-0.621 17.62,-1.879 5.8,-1.25 11.01,-3.281 15.63,-6.109 4.62,-2.82 8.34,-6.461 11.16,-10.922 2.82,-4.469 4.23,-9.918 4.23,-16.34 v -62.508",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,295.89333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path12",
    d: "m 2000.05,889.66 h 19.97 v 10.11 c 0,7.679 0.94,13.902 2.82,18.679 1.88,4.781 4.38,8.461 7.52,11.051 3.13,2.578 6.7,4.301 10.69,5.16 4,0.86 8.19,1.301 12.57,1.301 8.62,0 14.89,-0.563 18.81,-1.652 v -20.911 c -1.73,0.473 -3.57,0.821 -5.52,1.063 -1.97,0.23 -4.28,0.348 -6.94,0.348 -3.61,0 -6.7,-0.86 -9.28,-2.59 -2.59,-1.719 -3.88,-5.09 -3.88,-10.11 V 889.66 h 22.8 v -19.969 h -22.8 V 768.172 h -26.79 v 101.519 h -19.97 v 19.969",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,295.89333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13",
    d: "m 2081.59,889.66 h 19.97 v 10.11 c 0,7.679 0.95,13.902 2.83,18.679 1.88,4.781 4.38,8.461 7.52,11.051 3.13,2.578 6.69,4.301 10.68,5.16 4,0.86 8.19,1.301 12.58,1.301 8.62,0 14.88,-0.563 18.8,-1.652 v -20.911 c -1.73,0.473 -3.57,0.821 -5.52,1.063 -1.96,0.23 -4.27,0.348 -6.94,0.348 -3.6,0 -6.69,-0.86 -9.28,-2.59 -2.59,-1.719 -3.87,-5.09 -3.87,-10.11 V 889.66 h 22.79 v -19.969 h -22.79 V 768.172 h -26.8 v 101.519 h -19.97 v 19.969",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,295.89333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path14",
    d: "m 2179.35,935.961 h 26.78 v -62.27 h 0.48 c 3.28,5.469 8.18,10.047 14.69,13.739 6.49,3.679 13.74,5.519 21.73,5.519 13.31,0 23.81,-3.437 31.49,-10.34 7.67,-6.89 11.52,-17.238 11.52,-31.007 v -83.43 h -26.8 v 76.367 c -0.31,9.563 -2.34,16.492 -6.1,20.801 -3.76,4.308 -9.64,6.461 -17.63,6.461 -4.55,0 -8.62,-0.821 -12.22,-2.461 -3.61,-1.649 -6.66,-3.93 -9.16,-6.82 -2.51,-2.899 -4.47,-6.309 -5.88,-10.219 -1.41,-3.922 -2.12,-8.082 -2.12,-12.449 v -71.68 h -26.78 v 167.789",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,295.89333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path15",
    d: "m 2400.95,829.039 c -4.07,-2.668 -9.09,-4.277 -15.04,-4.828 -5.95,-0.539 -11.9,-1.359 -17.86,-2.461 -2.82,-0.48 -5.56,-1.141 -8.22,-2 -2.67,-0.859 -5.02,-2.039 -7.06,-3.531 -2.03,-1.489 -3.64,-3.438 -4.81,-5.867 -1.18,-2.43 -1.76,-5.372 -1.76,-8.813 0,-2.98 0.86,-5.488 2.58,-7.519 1.72,-2.04 3.8,-3.649 6.23,-4.821 2.43,-1.179 5.09,-2 7.99,-2.469 2.89,-0.468 5.52,-0.699 7.87,-0.699 2.97,0 6.19,0.391 9.63,1.168 3.45,0.781 6.7,2.121 9.76,4 3.05,1.883 5.6,4.262 7.64,7.16 2.03,2.903 3.05,6.469 3.05,10.7 z m 26.79,-33.848 c 0,-3.293 0.43,-5.64 1.29,-7.05 0.86,-1.411 2.55,-2.11 5.06,-2.11 0.78,0 1.72,0 2.82,0 1.09,0 2.34,0.16 3.76,0.469 v -18.57 c -0.94,-0.309 -2.16,-0.66 -3.65,-1.051 -1.49,-0.391 -3.01,-0.738 -4.58,-1.07 -1.56,-0.309 -3.14,-0.539 -4.7,-0.7 -1.57,-0.16 -2.9,-0.23 -3.99,-0.23 -5.49,0 -10.03,1.101 -13.63,3.293 -3.61,2.187 -5.96,6.019 -7.05,11.508 -5.33,-5.16 -11.87,-8.918 -19.63,-11.282 -7.75,-2.347 -15.24,-3.519 -22.44,-3.519 -5.49,0 -10.73,0.742 -15.74,2.23 -5.02,1.493 -9.44,3.672 -13.28,6.59 -3.84,2.891 -6.9,6.571 -9.17,11.039 -2.27,4.461 -3.4,9.672 -3.4,15.621 0,7.52 1.37,13.629 4.11,18.34 2.74,4.692 6.34,8.371 10.81,11.039 4.47,2.66 9.47,4.582 15.04,5.75 5.56,1.184 11.16,2.082 16.8,2.711 4.86,0.93 9.48,1.602 13.87,2 4.38,0.383 8.26,1.051 11.63,1.992 3.37,0.938 6.03,2.387 7.99,4.348 1.96,1.961 2.93,4.902 2.93,8.82 0,3.43 -0.82,6.25 -2.46,8.45 -1.65,2.203 -3.68,3.882 -6.11,5.05 -2.43,1.18 -5.14,1.961 -8.11,2.352 -2.98,0.398 -5.8,0.59 -8.46,0.59 -7.52,0 -13.71,-1.563 -18.56,-4.699 -4.86,-3.133 -7.6,-7.993 -8.23,-14.571 h -26.79 c 0.47,7.828 2.35,14.34 5.64,19.5 3.29,5.18 7.48,9.328 12.57,12.469 5.09,3.121 10.85,5.32 17.28,6.57 6.42,1.258 13,1.879 19.74,1.879 5.95,0 11.82,-0.621 17.62,-1.879 5.8,-1.25 11.01,-3.281 15.63,-6.109 4.62,-2.82 8.34,-6.461 11.16,-10.922 2.82,-4.469 4.23,-9.918 4.23,-16.34 v -62.508",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,295.89333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path16",
    d: "m 2575.09,768.172 h -26.33 v 16.918 h -0.47 c -3.29,-6.11 -8.18,-11.012 -14.69,-14.692 -6.5,-3.679 -13.12,-5.519 -19.85,-5.519 -15.98,0 -27.54,3.949 -34.66,11.859 -7.14,7.91 -10.7,19.871 -10.7,35.84 v 77.082 h 26.79 v -74.488 c 0,-10.652 2.04,-18.172 6.12,-22.563 4.07,-4.39 9.78,-6.578 17.15,-6.578 5.64,0 10.34,0.86 14.1,2.59 3.76,1.719 6.82,4.02 9.17,6.918 2.34,2.902 4.02,6.391 5.05,10.461 1.01,4.07 1.52,8.469 1.52,13.16 v 70.5 h 26.8 V 768.172",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,295.89333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path17",
    d: "m 2635.25,807.18 c 0.78,-7.84 3.76,-13.321 8.93,-16.45 5.17,-3.14 11.36,-4.699 18.57,-4.699 2.5,0 5.36,0.188 8.57,0.578 3.21,0.403 6.23,1.141 9.05,2.243 2.81,1.097 5.13,2.699 6.94,4.82 1.79,2.109 2.61,4.887 2.46,8.34 -0.16,3.437 -1.41,6.269 -3.76,8.457 -2.35,2.191 -5.37,3.953 -9.05,5.293 -3.68,1.316 -7.87,2.468 -12.57,3.398 -4.7,0.942 -9.49,1.961 -14.34,3.059 -5.01,1.09 -9.83,2.422 -14.45,3.992 -4.62,1.57 -8.77,3.687 -12.45,6.348 -3.69,2.66 -6.63,6.07 -8.81,10.222 -2.2,4.149 -3.29,9.278 -3.29,15.399 0,6.57 1.6,12.101 4.81,16.558 3.21,4.461 7.29,8.071 12.22,10.813 4.94,2.73 10.42,4.66 16.45,5.758 6.03,1.101 11.79,1.64 17.28,1.64 6.26,0 12.25,-0.66 17.97,-2 5.72,-1.328 10.89,-3.488 15.51,-6.449 4.62,-2.98 8.46,-6.859 11.52,-11.641 3.05,-4.777 4.97,-10.539 5.75,-17.269 h -27.96 c -1.26,6.422 -4.2,10.719 -8.82,12.922 -4.62,2.199 -9.9,3.289 -15.86,3.289 -1.87,0 -4.11,-0.16 -6.7,-0.473 -2.57,-0.308 -5.01,-0.898 -7.28,-1.758 -2.27,-0.871 -4.19,-2.121 -5.75,-3.761 -1.58,-1.649 -2.36,-3.797 -2.36,-6.457 0,-3.293 1.14,-5.961 3.41,-7.993 2.27,-2.039 5.25,-3.73 8.93,-5.058 3.68,-1.332 7.88,-2.461 12.58,-3.41 4.69,-0.93 9.55,-1.95 14.57,-3.039 4.85,-1.114 9.62,-2.43 14.33,-4.012 4.7,-1.559 8.89,-3.68 12.57,-6.328 3.68,-2.672 6.66,-6.043 8.94,-10.114 2.26,-4.07 3.39,-9.089 3.39,-15.039 0,-7.211 -1.64,-13.32 -4.93,-18.328 -3.29,-5.019 -7.56,-9.09 -12.8,-12.222 -5.25,-3.137 -11.08,-5.411 -17.51,-6.809 -6.43,-1.418 -12.77,-2.121 -19.03,-2.121 -7.69,0 -14.78,0.859 -21.27,2.582 -6.51,1.719 -12.15,4.348 -16.93,7.879 -4.77,3.519 -8.53,7.91 -11.28,13.16 -2.74,5.238 -4.19,11.469 -4.34,18.68 h 26.79",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,295.89333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path18",
    d: "m 2832.18,839.602 c -0.32,4.238 -1.22,8.308 -2.71,12.23 -1.49,3.918 -3.52,7.316 -6.11,10.219 -2.59,2.898 -5.72,5.25 -9.39,7.051 -3.7,1.796 -7.81,2.699 -12.35,2.699 -4.69,0 -8.96,-0.821 -12.8,-2.461 -3.85,-1.649 -7.13,-3.93 -9.87,-6.82 -2.75,-2.899 -4.94,-6.309 -6.59,-10.219 -1.64,-3.922 -2.54,-8.153 -2.69,-12.699 z m -62.51,-17.614 c 0,-4.707 0.66,-9.25 1.99,-13.636 1.33,-4.383 3.33,-8.223 6,-11.512 2.65,-3.289 6.02,-5.918 10.1,-7.871 4.07,-1.957 8.93,-2.938 14.57,-2.938 7.83,0 14.14,1.68 18.92,5.047 4.78,3.371 8.34,8.422 10.68,15.152 h 25.39 c -1.41,-6.57 -3.84,-12.449 -7.29,-17.609 -3.45,-5.18 -7.6,-9.519 -12.45,-13.051 -4.85,-3.531 -10.3,-6.191 -16.33,-7.992 -6.03,-1.797 -12.34,-2.699 -18.92,-2.699 -9.56,0 -18.02,1.57 -25.38,4.691 -7.37,3.141 -13.59,7.52 -18.69,13.168 -5.08,5.641 -8.92,12.371 -11.51,20.203 -2.58,7.84 -3.88,16.457 -3.88,25.86 0,8.621 1.37,16.801 4.11,24.551 2.75,7.757 6.66,14.57 11.76,20.449 5.09,5.871 11.23,10.539 18.45,13.988 7.2,3.43 15.35,5.16 24.43,5.16 9.56,0 18.14,-2 25.73,-5.988 7.6,-4 13.91,-9.281 18.92,-15.859 5.02,-6.582 8.66,-14.141 10.93,-22.68 2.27,-8.543 2.86,-17.352 1.77,-26.434 h -89.3",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,295.89333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path19",
    d: "m 2891.16,889.66 h 25.38 v -17.859 l 0.47,-0.473 c 4.08,6.742 9.4,12.024 15.98,15.863 6.58,3.84 13.87,5.758 21.85,5.758 13.33,0 23.82,-3.437 31.5,-10.34 7.67,-6.89 11.51,-17.238 11.51,-31.007 v -83.43 h -26.78 v 76.367 c -0.33,9.563 -2.36,16.492 -6.12,20.801 -3.76,4.308 -9.64,6.461 -17.62,6.461 -4.55,0 -8.62,-0.821 -12.22,-2.461 -3.6,-1.649 -6.66,-3.93 -9.17,-6.82 -2.5,-2.899 -4.46,-6.309 -5.87,-10.219 -1.42,-3.922 -2.12,-8.082 -2.12,-12.449 v -71.68 h -26.79 V 889.66",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,295.89333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path20",
    d: "m 3160.52,2219.19 v -570.95 c 0,0 69.63,72.41 144.83,55.7 0,0 142.04,130.9 236.73,208.89 94.7,77.98 298.01,139.25 414.99,114.19 116.97,-25.07 222.81,-72.42 222.81,-72.42 l -5.57,261.81 -1013.79,2.78",
    style: {
      fill: "#fbc707",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,295.89333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path21",
    d: "m 3639.56,1397.57 c 0,0 103.05,189.39 206.1,178.25 103.05,-11.14 248.7,-130.71 286.87,-217.24 41.78,-94.69 77.98,-314.72 11.14,-473.471 -31.51,-74.839 -142.04,-164.32 -231.16,-72.41 -89.13,91.91 -80.77,153.18 -111.41,169.891 -30.64,16.711 -19.5,8.351 -19.5,-64.059 0,-72.41 33.43,-130.902 97.48,-194.961 64.06,-64.058 122.55,-114.191 208.89,-103.05 86.34,11.14 91.91,22.281 91.91,22.281 v -435.61 l -1013.79,1.137 11.14,206.094 c 0,0 22.28,-13.922 91.91,25.066 69.63,38.992 61.28,122.551 61.28,122.551 0,0 50.13,41.77 50.13,100.262 0,58.488 25.06,161.539 75.2,203.308 50.13,41.782 108.62,245.091 108.62,245.091 0,0 197.74,-13.92 292.43,-5.57 94.7,8.36 211.67,75.2 214.46,119.76 2.78,44.57 -64.06,50.14 -83.56,80.77 -19.49,30.64 -30.63,-2.78 -83.55,25.07 -52.92,27.85 -97.48,11.14 -144.83,2.79 -47.34,-8.36 -147.61,-2.79 -147.61,-2.79 l 27.85,66.84",
    style: {
      fill: "#00a650",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,295.89333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path22",
    d: "m 3315.81,1703.94 c 0,0 -13.03,-91.21 45.6,-162.87 58.64,-71.67 143.33,-107.5 169.39,-120.53 26.06,-13.03 71.67,-65.15 71.67,-162.88 L 3574.81,1243 c 0,0 18.8,-48.05 -14.62,-96.09 0,0 8.35,-16.71 0,-29.24 0,0 4.18,-96.09 -39.69,-167.111 -43.87,-71.02 -129.51,-200.528 -137.86,-286.168 -8.36,-85.641 -56.4,-98.18 -56.4,-98.18 0,0 11.33,-154.57 -149.51,-154.57",
    style: {
      fill: "none",
      stroke: "#231f20",
      strokeWidth: 26.8744,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,295.89333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path23",
    d: "m 3316.49,1709.5 c -45.61,9.78 -78.86,17.24 -157.04,-51.16 v -333.18 c 0,0 79.06,-13.93 182.11,33.42 l -100.27,8.36 125.33,58.48 c 0,0 -142.04,-11.14 -133.68,-5.57 8.35,5.57 122.54,52.92 122.54,52.92 l -122.54,-2.79 103.05,50.14 c 0,0 -75.2,-5.57 -103.05,-8.36 0,0 22.28,33.42 75.19,38.99 0,0 -44.56,2.79 -75.19,-2.78 0,0 36.2,30.64 69.62,33.42 0,0 -50.13,11.14 -75.19,5.57 0,0 19.49,27.85 58.48,33.42 0,0 -55.7,8.36 -80.77,2.79 -25.06,-5.57 27.86,25.06 64.06,27.85 36.21,2.78 -33.42,13.93 -64.06,11.14 0,0 45.96,34.81 105.84,12.53 l 5.57,34.81",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,295.89333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path24",
    d: "m 3319.27,1699.76 c 173.38,192.17 316.2,343.3 566.78,337 310.43,-7.81 600.14,-267.1 595.32,-787.49 -4.86,-524.282 -292.44,-622.481 -409.42,-622.481 -116.97,0 -292.43,96.09 -288.26,342.57 0,0 12.54,52.221 31.34,0 18.8,-52.218 104.44,-225.597 221.41,-185.91 116.98,39.692 152.49,210.981 135.78,417.771 -16.71,206.8 -173.38,373.9 -327.95,373.9 -148.31,0 -246.48,-252.74 -246.48,-252.74",
    style: {
      fill: "none",
      stroke: "#231f20",
      strokeWidth: 26.8744,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,295.89333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path25",
    d: "m 2731.39,1333.18 c 7.02,18.38 26.4,63.48 52.79,78.32 33.42,18.8 51.52,29.94 51.52,29.94 -168.5,281.99 -357.19,453.27 -586.96,459.54 -128.92,3.52 -217.71,-75.82 -270.84,-146.14 16.76,27.15 34.98,52.77 54.92,76.44 104.3,123.84 246.42,192.04 400.18,192.04 239.27,0 380.97,-136.36 561.92,-336.94 l 24.88,15.76 c 64.06,38.99 133.44,-27.8 143.51,-51.12 v 568.16 h -994.29 v -239.03 c -57.89,-33 -110.87,-77.07 -156.76,-131.55 -123,-146.05 -188.58,-357.97 -188.58,-610.56 0,0 51.82,-0.18 52.18,0.18 13.8,140.06 58.15,303.23 189.06,405.83 0,0 -63.32,-216.89 -36.77,-406.01 h 80.87 c 7.74,124.98 90.02,300.93 273.01,332.02 -117.81,-46.66 -219.08,-179.27 -244.25,-332.02 h 27.65 c 29.57,179.42 167.91,323.65 309.34,323.65 137.37,0 233.29,-238.26 234.25,-240.7",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,295.89333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path26",
    d: "m 3792.75,943.602 c 16.71,-91.911 100.26,-252.063 270.15,-250.661 169.89,1.391 307.76,142.039 360.68,363.449 0,0 -29.93,-248.269 -189.39,-355.101 -143.44,-96.078 -265.98,-51.519 -311.94,-23.668 -45.95,27.848 -114.19,116.969 -125.33,164.32 -11.14,47.348 -9.75,105.829 -9.75,105.829 l 5.58,-4.168",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,295.89333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path27",
    d: "m 3238.51,1283.38 c 80.76,0 125.33,47.35 136.47,75.2 11.14,27.85 13.92,116.97 -8.36,161.54 -22.28,44.56 50.13,-36.21 66.84,-47.35 16.72,-11.14 30.64,-27.85 30.64,-27.85 0,0 -58.49,-44.56 -69.63,-133.69 0,0 25.07,27.86 55.71,55.71 0,0 -33.43,-50.14 -36.21,-83.56 0,0 50.13,69.63 80.77,86.34 0,0 -41.78,-47.34 -50.14,-91.91 0,0 11.15,33.42 69.63,58.49 0,0 -33.42,-61.27 -38.99,-75.2 0,0 25.07,33.42 66.84,52.92 0,0 -33.42,-38.99 -47.34,-66.84 0,0 22.28,13.92 52.91,19.49 30.64,5.57 -33.42,-33.42 -52.91,-50.13 -19.5,-16.71 -47.35,-47.35 -47.35,-47.35 l -33.42,41.78 c 0,0 -25.07,-11.14 -27.85,-50.13 0,0 -27.85,16.71 -27.85,66.84 0,0 -19.5,36.21 -44.57,44.56 -25.06,8.36 -75.19,11.14 -75.19,11.14",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,295.89333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path28",
    d: "m 3184.2,756.301 c 41.77,39.687 64.75,45.949 81.46,43.859 16.71,-2.09 33.42,-8.351 41.78,-25.058 l 29.24,27.148 c 0,0 -12.53,-48.039 -25.06,-62.66 -12.54,-14.621 -29.25,-29.25 -48.05,-41.781 -18.8,-12.528 -27.15,-22.981 -29.24,-37.598 -2.09,-14.621 -39.69,-41.781 -39.69,-41.781 l 2.09,-68.93 c 0,0 43.86,-16.711 100.26,0 0,0 -58.48,-39.691 -110.71,-37.602 z",
    style: {
      fill: "none",
      stroke: "#231f20",
      strokeWidth: 16.1246,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,295.89333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path29",
    d: "m 3261.48,1201.22 c 39.69,-4.18 100.27,-41.78 129.51,-75.2 l -50.13,16.71 41.78,-54.31 -37.6,12.54 43.86,-50.14 -43.86,6.27 39.68,-43.86 -37.59,8.35 35.51,-39.689 -31.34,4.179 c 0,0 43.87,-33.422 58.49,-81.461 l 2.09,52.219 22.98,10.442 -31.34,25.07 37.6,-8.36 -35.51,41.78 45.96,-14.62 -45.96,62.66 39.69,-14.62 -25.07,35.51 c 0,0 -2.08,39.69 29.25,58.49 0,0 14.62,-25.07 56.4,-29.25 41.77,-4.17 54.31,-6.26 54.31,-6.26 0,0 -20.18,-136.791 -48.05,-183.818 -33.42,-56.403 -100.26,-171.293 -108.62,-194.262 -8.35,-22.981 -20.88,-83.559 -29.24,-110.711 -8.35,-27.16 -6.27,96.09 -6.27,96.09 0,0 -16.71,-39.688 -41.77,-62.668 0,0 20.89,52.219 29.24,96.09 0,0 -2.09,-31.34 -39.69,-52.219 0,0 2.09,93.988 8.36,100.258 6.27,6.269 -33.42,16.711 -33.42,16.711 0,0 25.06,14.621 50.13,8.359 25.07,-6.27 -56.4,31.328 -56.4,31.328 h 60.58 l -56.4,45.953 58.49,-14.621 c 0,0 -60.58,58.488 -81.47,62.668 0,0 33.42,2.094 58.49,-16.707 0,0 -43.87,48.039 -68.93,52.219 l 60.57,-18.801 c 0,0 -45.95,52.221 -66.84,54.311 l 68.93,-18.8 c 0,0 -25.06,41.77 -52.22,48.04 l 50.13,-8.35 c 0,0 -35.51,39.68 -66.84,43.86 0,0 20.89,18.8 54.31,-2.09 0,0 -39.69,37.6 -60.58,41.78 0,0 35.51,10.44 64.76,-8.36 0,0 -35.51,39.69 -60.58,43.87 l 62.67,-6.27 c 0,0 -16.71,10.45 -27.16,18.8 -10.44,8.36 -20.89,20.89 -20.89,20.89",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,295.89333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path30",
    d: "m 3234.33,660.211 c 14.62,10.449 48.04,16.711 48.04,16.711 0,0 -12.53,-27.152 -41.78,-39.692 0,0 25.07,0 52.23,14.629 0,0 -25.07,-29.25 -52.23,-37.597 0,0 45.96,8.347 60.58,16.707 0,0 -25.06,-35.508 -54.31,-43.867 14.62,2.089 45.96,-4.18 68.93,12.527 0,0 -12.53,-14.617 -33.42,-25.059 -20.89,-10.449 -39.69,-10.449 -39.69,-10.449 0,0 64.76,2.09 94,14.629 0,0 -50.13,-52.219 -85.64,-54.309 -35.51,-2.089 -58.49,-10.453 -58.49,-10.453 l 2.79,106.532 38.99,39.691",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,295.89333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path31",
    d: "m 3235.72,748.641 c -12.88,-7.301 -20.89,-29.25 -19.5,-41.782 1.4,-12.527 11.15,-16.711 26.46,-5.57 15.32,11.141 26.46,23.68 41.78,32.031 15.32,8.36 -6.96,38.989 -48.74,15.321",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,295.89333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path32",
    d: "M 3169.57,1257.62 V 795.988 c 0,0 29.25,29.242 66.85,37.59 0,0 -43.87,0 -37.6,2.094 6.26,2.09 14.62,18.797 50.13,25.066 0,0 -16.71,16.711 -45.95,8.364 0,0 22.97,22.968 52.22,20.878 0,0 -29.25,14.629 -52.22,10.45 0,0 25.06,16.711 56.39,14.621 0,0 -27.15,18.801 -56.39,16.711 0,0 18.8,14.617 52.22,10.437 0,0 -20.89,20.891 -56.4,20.891 0,0 20.89,18.801 52.22,14.621 0,0 -18.8,20.891 -52.22,18.801 0,0 16.71,16.718 45.95,12.538 0,0 -18.8,16.71 -41.77,16.71 0,0 2.08,18.8 39.68,16.71 -8.35,2.09 -25.06,14.62 -48.04,12.53 0,0 18.8,18.8 39.69,22.98 0,0 -18.8,12.53 -37.6,10.44 0,0 16.71,18.8 43.86,18.8 0,0 -22.97,20.89 -43.86,12.54 0,0 8.35,27.15 37.6,29.24 0,0 -20.89,8.36 -41.78,2.09 0,0 18.8,16.71 54.31,16.71 0,0 -27.15,18.8 -48.04,16.71 0,0 16.71,20.89 39.69,14.62 l -43.87,14.62 -25.07,43.87",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,295.89333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path33",
    d: "m 3184.2,501.461 c 0,0 6.26,-12.531 4.17,-37.602 0,0 18.8,22.981 16.71,45.95 0,0 14.63,-18.797 14.63,-43.86 l 6.26,52.223 c 0,0 18.8,-37.602 20.89,-52.223 l 4.18,54.313 14.62,-10.453 6.27,39.691 -85.65,-22.969 -2.08,-25.07",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,295.89333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path34",
    d: "m 3447.39,1169.19 c 62.67,61.27 66.84,63.36 127.42,73.81",
    style: {
      fill: "none",
      stroke: "#231f20",
      strokeWidth: 16.1246,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,295.89333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path35",
    d: "m 3560.19,1144.82 c -48.05,-22.98 -87.73,4.18 -114.89,37.6",
    style: {
      fill: "none",
      stroke: "#231f20",
      strokeWidth: 16.1246,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,295.89333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path36",
    d: "m 3482.9,1191.82 c 3.13,-37.6 28.2,-45.95 28.2,-45.95 0,0 -12.53,-8.36 -47,13.57 -24.48,15.58 18.8,32.38 18.8,32.38",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,295.89333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path37",
    d: "m 3552.88,1190.25 c 0,-7.21 -5.85,-13.05 -13.06,-13.05 -7.21,0 -13.05,5.84 -13.05,13.05 0,7.21 5.84,13.06 13.05,13.06 7.21,0 13.06,-5.85 13.06,-13.06",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,295.89333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path38",
    d: "m 3696.05,1209.58 c 32.03,-40.39 69.63,-52.92 69.63,-52.92 l -15.32,26.46 c 0,0 30.63,-23.68 61.27,-30.64 l -36.21,33.42 c 0,0 37.6,-20.89 73.81,-30.63 l -34.82,29.24 c 0,0 37.6,-18.1 72.42,-22.28 l -22.28,16.71 c 0,0 32.03,-11.14 61.27,-15.32 l -29.24,20.89 c 0,0 18.1,-8.36 59.88,-6.96 l -26.46,11.14 c 0,0 45.95,0 66.84,2.78 0,0 -26.46,11.14 -45.95,12.54 0,0 26.45,6.96 44.56,4.17 0,0 -83.56,13.93 -107.23,20.89 0,0 0,-12.53 27.85,-20.89 -5.57,-1.39 -32.03,-2.78 -54.31,9.75 0,0 0,-9.75 16.71,-20.89 0,0 -36.2,5.57 -54.31,16.71 0,0 2.79,-9.74 20.89,-20.88 0,0 -37.6,8.35 -50.13,18.1 l 6.96,-15.32 c 0,0 -22.28,1.39 -38.99,12.53 v -13.92 c 0,0 -15.32,4.18 -33.42,18.1 0,0 -6.96,-8.35 6.96,-20.89 z m 5.57,127.42 c 33.42,6.26 116.97,20.88 177.55,18.8 60.58,-2.09 127.42,-39.69 175.46,-71.03 48.04,-31.33 37.6,-79.37 16.71,-100.26 -20.89,-20.89 -102.35,-75.2 -210.97,-94 -108.62,-18.8 -238.13,4.18 -238.13,4.18 h -50.13 c 8.35,18.8 2.09,48.04 2.09,48.04 16.71,29.25 10.44,85.65 10.44,85.65 l 25.07,20.89 c 2.09,31.33 -10.45,62.66 -10.45,62.66 l 10.45,22.98 c 0,0 58.49,-4.18 91.91,2.09",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,295.89333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path39",
    d: "m 4353.95,1263.89 c 66.84,0 104.44,6.26 104.44,6.26 0,0 -123.24,16.71 -206.8,8.36 0,0 35.51,-14.62 102.36,-14.62 z m -14.63,100.26 c 58.49,12.53 102.36,37.6 102.36,37.6 -50.13,-20.89 -142.04,-33.42 -196.35,-35.51 0,0 35.51,-14.62 93.99,-2.09 z m 16.72,96.09 c 45.95,25.06 56.39,71.02 56.39,71.02 -39.68,-43.87 -123.24,-87.73 -173.37,-102.35 0,0 71.02,6.26 116.98,31.33 z m -58.49,81.46 c -37.6,-33.42 -71.02,-58.49 -71.02,-58.49 106.53,20.89 87.73,62.67 144.13,127.42 0,0 -35.51,-35.51 -73.11,-68.93 z m 29.24,167.11 c -22.98,-41.78 -48.04,-106.53 -123.24,-148.31 0,0 29.24,-6.27 75.2,41.78 45.95,48.04 48.04,106.53 48.04,106.53 z m -626.65,16.71 c 20.89,-27.16 33.42,-54.31 35.51,-73.11 2.09,-18.8 4.18,64.75 -22.98,91.91 z m 60.58,60.58 c 14.62,-29.25 25.06,-64.76 29.24,-100.27 0,0 8.36,66.85 -14.62,110.71 z m 77.28,54.31 c 12.54,-48.05 18.8,-112.8 18.8,-112.8 l 6.27,127.42 z m 94,43.86 c 6.27,-58.48 -2.09,-116.97 -10.44,-150.39 0,0 45.95,37.59 35.51,148.3 -6.87,72.82 -25.07,2.09 -25.07,2.09 z m 116.98,25.07 c 2.09,-62.67 -12.54,-129.51 -35.51,-179.64 0,0 66.84,87.73 66.84,171.28 0,46.15 -31.33,8.36 -31.33,8.36 z m 223.5,-77.29 c -12.53,-48.04 -64.75,-131.6 -114.88,-185.91 0,0 91.91,50.14 135.77,169.2 z m -114.88,62.66 c 2.08,-60.57 -22.98,-148.3 -106.53,-233.94 0,0 114.88,37.59 137.86,217.23 z m -664.26,-453.27 c 168.5,281.99 357.2,453.27 586.97,459.54 229.77,6.27 332.12,-250.66 332.12,-250.66 0,0 114.89,-263.19 43.87,-622.47 0,0 39.69,434.47 -192.17,616.2 0,0 112.79,-405.23 -43.87,-703.929 0,0 104.44,662.159 -375.99,634.999 0,0 -82.16,-6.26 -151.79,-92.6 -40.39,-50.09 -91.91,-157.36 -91.91,-157.36 0,0 -22.28,67.54 -55.7,86.34 -33.42,18.8 -51.53,29.94 -51.53,29.94",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,295.89333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path40",
    d: "m 3700.14,1725.52 c -52.22,58.49 -33.42,87.73 -150.4,119.07 0,0 54.31,-22.98 79.38,-62.67 25.07,-39.69 64.75,-83.56 64.75,-83.56 l 6.27,27.16",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,295.89333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path41",
    d: "m 1014.33,1078.03 c 0,56.63 11.36,110.58 31.61,159.94 l -361.163,109.71 c -34.711,-197.79 -206.894,-348.2 -414.613,-348.2 -57.535,0 -112.332,11.59 -162.281,32.48 L 0,681.309 c 194.758,-37.137 342.031,-208.118 342.031,-413.688 0,-54.922 -10.808,-107.23 -29.945,-155.34 L 681.762,0 c 38.187,193.41 208.648,339.34 413.288,339.34 46.85,0 91.76,-7.949 133.87,-22.07 l 108.14,351.39 c -185.04,44.488 -322.73,210.649 -322.73,409.37",
    style: {
      fill: "#ed1c24",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,295.89333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path42",
    d: "M 509.727,605.859 H 402.664 V 930.02 H 509.727 V 605.859",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,295.89333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path43",
    d: "M 618.266,714.398 H 294.105 V 821.461 H 618.266 V 714.398",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,295.89333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path44",
    d: "M 852.57,424.801 V 213.672 h -98.379 v 470.797 h 98.379 v -178.36 h 183.58 v 178.36 h 98.37 V 213.672 h -98.37 V 424.801 H 852.57",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,295.89333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path45",
    d: "M 1562.83,601.199 H 1313 v -99.008 h 229.51 V 418.898 H 1313 V 296.922 h 260.96 v -83.25 H 1216.6 v 470.797 h 346.23 v -83.27",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,295.89333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path46",
    d: "m 1735.6,213.672 h -98.37 v 470.797 h 335.09 v -83.27 H 1735.6 V 494.98 h 207.21 V 411.691 H 1735.6 V 213.672",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,295.89333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path47",
    d: "m 2113.27,392.031 h 119.96 l -58.38,186.199 h -1.26 z m -59.01,-178.359 h -103.65 l 167.89,470.797 h 113.42 l 165.91,-470.797 h -106.89 l -30.14,97.066 h -173.77 l -32.77,-97.066",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,295.89333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path48",
    d: "m 2664.38,477.281 c 51.15,0 76.08,17.699 76.08,64.258 0,24.883 -11.11,61.602 -68.85,61.602 h -122.62 v -125.86 z m -211.74,207.188 h 237.98 c 125.23,0 148.2,-92.43 148.2,-133.11 0,-51.781 -26.22,-96.379 -72.79,-112.121 38.71,-17.066 59.68,-31.468 59.68,-119.347 0,-68.86 0,-85.86 20.97,-93.789 v -12.43 h -108.85 c -6.54,22.289 -10.5,46.527 -10.5,95.047 0,64.281 -3.88,89.211 -76.71,89.211 H 2548.99 V 213.672 h -96.35 v 470.797",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,295.89333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path49",
    d: "m 3004.9,213.672 h -98.36 v 470.797 h 98.36 V 213.672",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,295.89333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path50",
    d: "m 107.539,1696.58 c -25.9452,-2.76 -47.9179,3.37 -47.9179,36.12 v 55.4 l 38.1523,4.59 v -55.71 c 0,-6.73 3.3556,-9.79 9.4606,-8.87 5.797,0.61 10.071,3.98 10.071,10.71 v 41.32 c 0,41.22 -57.6839,29.9 -57.6839,85.91 v 20.51 c 0,33.06 21.9727,43.46 47.9179,46.22 25.941,2.75 47.918,-3.37 47.918,-36.42 v -31.84 l -38.152,-4.59 v 32.14 c 0,6.73 -3.356,9.79 -9.157,9.18 -5.796,-0.61 -10.3746,-3.98 -10.3746,-11.02 v -17.44 c 0,-37.35 57.6836,-23.57 57.6836,-86.83 v -43.47 c 0,-33.05 -21.977,-43.46 -47.918,-45.91",
    style: {
      fill: "#762661",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,295.89333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path51",
    d: "m 219.141,1696.58 c -25.637,-2.76 -47.309,3.37 -47.309,35.81 v 155.09 c 0,32.44 21.672,42.54 47.309,45.3 25.636,2.75 47.308,-3.37 47.308,-35.82 v -32.44 l -39.375,-4.59 v 33.67 c 0,5.51 -2.441,7.96 -7.629,7.35 -4.882,-0.62 -8.547,-3.37 -8.547,-9.19 v -156 c 0,-5.51 2.442,-7.96 7.938,-7.35 4.883,0.62 8.238,3.37 8.238,8.88 v 49.89 l 39.375,4.9 v -50.51 c 0,-32.44 -21.672,-42.54 -47.308,-44.99",
    style: {
      fill: "#762661",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,295.89333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path52",
    d: "m 340.324,1696.58 v 119.88 l -18.922,-2.44 v -112.85 l -38.457,-4.59 v 231.61 l 38.457,4.59 v -84.69 l 18.922,2.45 v 77.65 l 38.457,4.59 v -231.61 l -38.457,-4.59",
    style: {
      fill: "#762661",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,295.89333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path53",
    d: "m 450.816,1906.76 -1.222,-0.31 -12.817,-114.37 22.586,2.14 z m 15.872,-209.87 -4.883,64.28 -28.692,-2.76 -6.41,-57.24 -35.402,-4.28 30.519,230.99 60.129,4.29 24.723,-231 -39.984,-4.28",
    style: {
      fill: "#762661",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,295.89333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path54",
    d: "m 559.059,1812.49 v -111.32 l -38.153,-4.59 v 230.99 l 72.641,4.29 v -34.28 l -34.488,-2.45 v -49.89 l 34.488,3.06 v -33.67 l -34.488,-2.14",
    style: {
      fill: "#762661",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,295.89333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path55",
    d: "m 645.434,1812.48 v -111.31 l -38.153,-4.59 v 230.99 l 72.641,4.29 v -34.28 l -34.488,-2.45 v -49.89 l 34.488,3.06 v -33.67 l -34.488,-2.15",
    style: {
      fill: "#762661",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,295.89333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path56",
    d: "m 750.941,1696.58 v 119.88 l -18.921,-2.44 v -112.85 l -38.457,-4.59 v 231.61 l 38.457,4.59 v -84.69 l 18.921,2.45 v 77.65 l 38.457,4.59 v -231.61 l -38.457,-4.59",
    style: {
      fill: "#762661",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,295.89333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path57",
    d: "m 861.324,1906.76 -1.222,-0.31 -12.817,-114.37 22.586,2.14 z m 15.875,-209.87 -4.883,64.28 -28.691,-2.76 -6.41,-57.24 -35.406,-4.28 30.523,230.99 60.129,4.29 24.719,-231 -39.981,-4.28",
    style: {
      fill: "#762661",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,295.89333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path58",
    d: "m 979.449,1696.58 c -25.953,-2.75 -47.922,3.37 -47.922,36.42 v 195.19 l 38.461,4.59 v -195.49 c 0,-6.43 3.043,-9.49 8.852,-8.88 5.797,0.62 10.062,3.98 10.062,10.72 v 189.06 l 38.458,4.59 v -190.29 c 0,-33.05 -21.97,-43.46 -47.911,-45.91",
    style: {
      fill: "#762661",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,295.89333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path59",
    d: "m 1094.19,1696.58 c -25.94,-2.76 -47.91,3.37 -47.91,36.12 v 55.4 l 38.15,4.59 v -55.71 c 0,-6.73 3.36,-9.79 9.46,-8.87 5.8,0.61 10.08,3.98 10.08,10.71 v 41.32 c 0,41.32 -57.69,30 -57.69,85.91 v 20.51 c 0,33.06 21.97,43.46 47.91,46.22 25.95,2.75 47.92,-3.37 47.92,-36.42 v -31.84 l -38.14,-4.59 v 32.14 c 0,6.73 -3.37,9.79 -9.16,9.18 -5.8,-0.61 -10.38,-3.98 -10.38,-11.02 v -17.44 c 0,-37.35 57.68,-23.57 57.68,-86.83 v -43.47 c 0,-33.05 -21.97,-43.46 -47.92,-45.91",
    style: {
      fill: "#762661",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,295.89333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path60",
    d: "m 1162.07,1697.2 v 230.37 l 73.55,4.29 v -34.28 l -35.4,-2.45 v -49.89 l 35.4,3.06 v -33.67 l -35.4,-2.14 v -81.73 l 35.4,3.06 v -33.67 l -73.55,-3.06 v 0.11",
    style: {
      fill: "#762661",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,295.89333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path61",
    d: "m 1415.6,1826.46 -19.43,-3.06 v 109.89 l -24.82,-2.96 v -130.9 l 44.25,2.04 v 24.99",
    style: {
      fill: "#762661",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,295.89333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path62",
    d: "m 1609.83,1822.28 v 88.46 l 8.54,0.31 c 0.71,0 1.83,0 2.44,-0.51 0.71,-0.61 0.82,-1.64 0.82,-2.45 v -81.42 c 0,-3.27 -2.85,-3.98 -4.48,-4.19 l -7.43,-0.2 z m 6.51,-21.73 c 19.02,0.81 28.99,10.41 28.99,27.85 v 81.42 c 0,7.55 -1.93,13.06 -5.9,16.84 -4.78,4.48 -12.01,6.22 -23.51,5.61 l -27.67,-1.43 v -131.31 l 27.98,1.12 0.11,-0.1",
    style: {
      fill: "#762661",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,295.89333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path63",
    d: "m 1291.99,1832.48 v 66.32 l 11.28,0.92 c 5.5,0.31 8.85,-2.76 8.85,-9.18 v -45.3 c 0,-6.74 -4.26,-11.02 -10.37,-11.94 -2.85,-0.41 -9.76,-0.82 -9.76,-0.82 z m 31.13,-135.59 40.29,4.28 -29.92,111.31 c 11.29,7.66 17.7,20.21 17.7,37.35 v 44.38 c 0,33.36 -21.66,38.88 -49.14,37.34 l -48.22,-2.44 v -232.22 l 38.16,4.59 v 102.43 c 3.04,0.21 5.9,0.41 8.54,0.62 l 22.59,-107.64",
    style: {
      fill: "#762661",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,295.89333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path64",
    d: "m 1458.33,1914.62 4.48,-57.85 -10.38,-0.82 z m -7.32,-81.12 12.3,1.23 2.65,-35.41 25.84,2.76 -14.04,130.8 -36.42,-2.55 -17.3,-131.01 23.4,2.86 3.57,31.43 v -0.11",
    style: {
      fill: "#762661",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,295.89333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path65",
    d: "m 1524.96,1890.84 17.81,-91.11 28.28,2.66 2.14,131.51 -22.59,-3.36 2.34,-90.61 -15.36,93.26 -31.84,-2.65 v -130.91 l 21.77,2.86 -2.55,88.35",
    style: {
      fill: "#762661",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,295.89333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path66",
    d: "m 1370.94,1752.7 0.51,21.32 274.39,4.59 -0.61,-25.61 -274.19,-0.3 h -0.1",
    style: {
      fill: "#762661",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,295.89333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path67",
    d: "M 43.5625,2214.4 H 74.043 l 30.961,-131.04 h 0.476 l 34.563,131.04 h 30.719 l 33.601,-131.04 h 0.481 l 31.918,131.04 h 30.484 L 219.965,2043.04 H 189.48 l -34.316,131.04 H 154.68 L 119.641,2043.04 H 88.6797 L 43.5625,2214.4",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,295.89333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path68",
    d: "m 295.805,2167.12 h 27.359 v -124.08 h -27.359 z m 0,47.28 h 27.359 v -25.92 h -27.359 v 25.92",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,295.89333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path69",
    d: "m 365.645,2214.4 h 27.359 v -171.36 h -27.359 v 171.36",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,295.89333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path70",
    d: "m 435.488,2214.4 h 27.356 v -171.36 h -27.356 v 171.36",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,295.89333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path71",
    d: "m 505.324,2214.4 h 27.36 v -97.44 l 49.437,50.16 h 33.602 l -47.52,-45.6 52.078,-78.48 h -33.359 l -37.918,60.24 -16.32,-15.84 v -44.4 h -27.36 v 171.36",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,295.89333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path72",
    d: "m 702.363,2061.28 c 6.078,0 11.356,1.28 15.84,3.84 4.477,2.56 8.156,5.92 11.039,10.08 2.883,4.16 5,8.84 6.363,14.04 1.356,5.2 2.036,10.52 2.036,15.96 0,5.28 -0.68,10.56 -2.036,15.84 -1.363,5.28 -3.48,9.96 -6.363,14.04 -2.883,4.08 -6.562,7.4 -11.039,9.96 -4.484,2.56 -9.762,3.84 -15.84,3.84 -6.086,0 -11.363,-1.28 -15.84,-3.84 -4.484,-2.56 -8.16,-5.88 -11.043,-9.96 -2.878,-4.08 -5,-8.76 -6.355,-14.04 -1.363,-5.28 -2.039,-10.56 -2.039,-15.84 0,-5.44 0.676,-10.76 2.039,-15.96 1.355,-5.2 3.477,-9.88 6.355,-14.04 2.883,-4.16 6.559,-7.52 11.043,-10.08 4.477,-2.56 9.754,-3.84 15.84,-3.84 z m 0,-21.6 c -9.922,0 -18.761,1.64 -26.519,4.92 -7.766,3.28 -14.321,7.8 -19.684,13.56 -5.359,5.76 -9.437,12.64 -12.234,20.64 -2.805,8 -4.207,16.8 -4.207,26.4 0,9.44 1.402,18.16 4.207,26.16 2.797,8 6.875,14.88 12.234,20.64 5.363,5.76 11.918,10.28 19.684,13.56 7.758,3.28 16.597,4.92 26.519,4.92 9.922,0 18.758,-1.64 26.516,-4.92 7.762,-3.28 14.324,-7.8 19.684,-13.56 5.359,-5.76 9.441,-12.64 12.242,-20.64 2.797,-8 4.199,-16.72 4.199,-26.16 0,-9.6 -1.402,-18.4 -4.199,-26.4 -2.801,-8 -6.883,-14.88 -12.242,-20.64 -5.36,-5.76 -11.922,-10.28 -19.684,-13.56 -7.758,-3.28 -16.594,-4.92 -26.516,-4.92",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,295.89333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path73",
    d: "m 799.797,2167.12 h 25.926 v -17.28 h 0.715 c 2.078,3.04 4.324,5.84 6.718,8.4 2.403,2.56 5.078,4.72 8.043,6.48 2.961,1.76 6.36,3.16 10.199,4.2 3.84,1.04 8.239,1.56 13.2,1.56 7.519,0 14.523,-1.68 21,-5.04 6.48,-3.36 11.082,-8.56 13.8,-15.6 4.637,6.4 10,11.44 16.079,15.12 6.078,3.68 13.683,5.52 22.804,5.52 13.114,0 23.313,-3.2 30.598,-9.6 7.277,-6.4 10.918,-17.12 10.918,-32.16 v -85.68 h -27.356 v 72.48 c 0,4.96 -0.164,9.48 -0.484,13.56 -0.324,4.08 -1.242,7.6 -2.758,10.56 -1.523,2.96 -3.804,5.24 -6.844,6.84 -3.035,1.6 -7.195,2.4 -12.472,2.4 -9.285,0 -16.008,-2.88 -20.164,-8.64 -4.164,-5.76 -6.239,-13.92 -6.239,-24.48 v -72.72 h -27.363 v 79.68 c 0,8.64 -1.558,15.16 -4.679,19.56 -3.118,4.4 -8.84,6.6 -17.157,6.6 -3.527,0 -6.926,-0.72 -10.199,-2.16 -3.281,-1.44 -6.164,-3.52 -8.644,-6.24 -2.481,-2.72 -4.481,-6.08 -6,-10.08 -1.52,-4 -2.282,-8.56 -2.282,-13.68 v -73.68 h -27.359 v 124.08",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,295.89333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path74",
    d: "m 1020.59,2167.12 h 25.93 v -17.28 h 0.71 c 2.08,3.04 4.33,5.84 6.72,8.4 2.41,2.56 5.08,4.72 8.05,6.48 2.95,1.76 6.35,3.16 10.2,4.2 3.83,1.04 8.23,1.56 13.19,1.56 7.52,0 14.53,-1.68 21.01,-5.04 6.47,-3.36 11.07,-8.56 13.79,-15.6 4.64,6.4 10,11.44 16.08,15.12 6.08,3.68 13.68,5.52 22.81,5.52 13.11,0 23.31,-3.2 30.6,-9.6 7.27,-6.4 10.91,-17.12 10.91,-32.16 v -85.68 h -27.35 v 72.48 c 0,4.96 -0.17,9.48 -0.49,13.56 -0.32,4.08 -1.24,7.6 -2.76,10.56 -1.52,2.96 -3.8,5.24 -6.84,6.84 -3.03,1.6 -7.19,2.4 -12.47,2.4 -9.28,0 -16.01,-2.88 -20.16,-8.64 -4.17,-5.76 -6.24,-13.92 -6.24,-24.48 v -72.72 h -27.37 v 79.68 c 0,8.64 -1.55,15.16 -4.68,19.56 -3.12,4.4 -8.84,6.6 -17.15,6.6 -3.53,0 -6.93,-0.72 -10.2,-2.16 -3.28,-1.44 -6.17,-3.52 -8.65,-6.24 -2.48,-2.72 -4.48,-6.08 -6,-10.08 -1.52,-4 -2.28,-8.56 -2.28,-13.68 v -73.68 h -27.36 v 124.08",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,295.89333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path75",
    d: "m 1326.6,2116 c -0.33,4.32 -1.24,8.48 -2.76,12.48 -1.53,4 -3.6,7.48 -6.24,10.44 -2.65,2.96 -5.85,5.36 -9.6,7.2 -3.77,1.84 -7.97,2.76 -12.61,2.76 -4.8,0 -9.16,-0.84 -13.07,-2.52 -3.93,-1.68 -7.29,-4 -10.09,-6.96 -2.8,-2.96 -5.03,-6.44 -6.71,-10.44 -1.68,-4 -2.61,-8.32 -2.76,-12.96 z m -63.84,-18 c 0,-4.8 0.68,-9.44 2.03,-13.92 1.36,-4.48 3.4,-8.4 6.13,-11.76 2.72,-3.36 6.15,-6.04 10.31,-8.04 4.16,-2 9.13,-3 14.89,-3 7.99,0 14.44,1.72 19.32,5.16 4.88,3.44 8.51,8.6 10.92,15.48 h 25.91 c -1.44,-6.72 -3.92,-12.72 -7.43,-18 -3.53,-5.28 -7.77,-9.72 -12.72,-13.32 -4.96,-3.6 -10.52,-6.32 -16.68,-8.16 -6.16,-1.83 -12.6,-2.76 -19.32,-2.76 -9.76,0 -18.41,1.6 -25.93,4.8 -7.52,3.2 -13.88,7.68 -19.07,13.44 -5.2,5.76 -9.12,12.64 -11.77,20.64 -2.63,8 -3.96,16.8 -3.96,26.4 0,8.8 1.41,17.16 4.2,25.08 2.8,7.92 6.81,14.88 12.01,20.88 5.2,6 11.47,10.76 18.84,14.28 7.35,3.52 15.68,5.28 24.95,5.28 9.76,0 18.52,-2.04 26.28,-6.12 7.76,-4.08 14.2,-9.48 19.32,-16.2 5.13,-6.72 8.84,-14.44 11.17,-23.16 2.31,-8.72 2.91,-17.72 1.79,-27 h -91.19",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,295.89333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path76",
    d: "m 1386.83,2167.12 h 25.92 v -18.24 l 0.48,-0.48 c 4.16,6.88 9.6,12.28 16.32,16.2 6.72,3.92 14.16,5.88 22.32,5.88 13.6,0 24.32,-3.52 32.16,-10.56 7.84,-7.04 11.76,-17.6 11.76,-31.68 v -85.2 h -27.36 v 78 c -0.32,9.76 -2.4,16.84 -6.24,21.24 -3.84,4.4 -9.84,6.6 -18,6.6 -4.64,0 -8.8,-0.84 -12.48,-2.52 -3.68,-1.68 -6.8,-4 -9.36,-6.96 -2.56,-2.96 -4.56,-6.44 -6,-10.44 -1.44,-4 -2.16,-8.25 -2.16,-12.72 v -73.2 h -27.36 v 124.08",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,295.89333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path77",
    d: "m 1616.03,2167.12 h 27.36 v -124.08 h -27.36 z m 0,47.28 h 27.36 v -25.92 h -27.36 v 25.92",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,295.89333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path78",
    d: "m 1685.15,2167.12 h 25.92 v -17.28 h 0.72 c 2.07,3.04 4.32,5.84 6.71,8.4 2.41,2.56 5.08,4.72 8.05,6.48 2.96,1.76 6.35,3.16 10.2,4.2 3.83,1.04 8.23,1.56 13.19,1.56 7.52,0 14.53,-1.68 21.01,-5.04 6.48,-3.36 11.07,-8.56 13.79,-15.6 4.64,6.4 10,11.44 16.08,15.12 6.08,3.68 13.69,5.52 22.81,5.52 13.11,0 23.31,-3.2 30.6,-9.6 7.27,-6.4 10.92,-17.12 10.92,-32.16 v -85.68 h -27.36 v 72.48 c 0,4.96 -0.16,9.48 -0.49,13.56 -0.32,4.08 -1.24,7.6 -2.76,10.56 -1.52,2.96 -3.8,5.24 -6.84,6.84 -3.03,1.6 -7.19,2.4 -12.47,2.4 -9.28,0 -16.01,-2.88 -20.16,-8.64 -4.17,-5.76 -6.24,-13.92 -6.24,-24.48 v -72.72 h -27.37 v 79.68 c 0,8.64 -1.55,15.16 -4.67,19.56 -3.12,4.4 -8.85,6.6 -17.16,6.6 -3.53,0 -6.93,-0.72 -10.2,-2.16 -3.28,-1.44 -6.16,-3.52 -8.65,-6.24 -2.48,-2.72 -4.48,-6.08 -6,-10.08 -1.51,-4 -2.28,-8.56 -2.28,-13.68 v -73.68 h -27.35 v 124.08",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,295.89333)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3b243886aec45518bc2244aedc34eae1.svg";
export { ForwardRef as ReactComponent };